export default __webpack_public_path__ + "static/media/work-gray.24a731bd.svg";